import jsPDF from 'jspdf';
import { toCanvas } from 'html-to-image';

// Filter function to exclude certain elements from PDF
const filter = (node: HTMLElement): boolean => {
  const exclusionClasses = [
    'report-card-tooltip-icon-wrapper',
    'Polaris-Choice',
    'report-download-wrapper',
    'reload-button-wrapper',
    'no-print',
  ];
  return !exclusionClasses.some((classname) =>
    node.classList?.contains(classname)
  );
};

export const downloadReport = async (
  componentRef: React.RefObject<HTMLDivElement>,
  fileName: string
): Promise<void> => {
  if (!componentRef.current) {
    return;
  }

  try {
    const canvas = await toCanvas(componentRef.current, {
      cacheBust: true,
      filter,
      backgroundColor: '#ffffff',
      pixelRatio: 2, // Higher quality
    });

    const imgWidth = 208; // A4 width minus margins (210 - 2)
    const pageHeight = 295; // A4 height
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF({
      orientation: 'p', // Portrait
      unit: 'mm',
      format: 'a4',
      compress: true,
    });

    let position = 0;

    // Add first page
    pdf.addImage(imgData, 'PNG', 1, 7, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Add additional pages if content is longer than one page
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 1, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`${fileName}-report-by-analyzely.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};
